function responseText(response) {
  return response.text();
}

export default function(url) {
  return fetch(url).then(responseText);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-fetch/src/text.js
// module id = 66
// module chunks = 0